import { render, staticRenderFns } from "./AwemeData.vue?vue&type=template&id=5cae5407&scoped=true"
import script from "./AwemeData.vue?vue&type=script&lang=js"
export * from "./AwemeData.vue?vue&type=script&lang=js"
import style0 from "./AwemeData.vue?vue&type=style&index=0&id=5cae5407&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae5407",
  null
  
)

export default component.exports